import React from 'react';
import { GiftIcon } from 'lucide-react';
import { bonuses } from '../../data/bonuses';
export function Bonuses() {
  return <section className="bg-navy px-5 py-7 text-white" data-id="element-7" data-mp="1hjhf3s4p892z">
      <div className="mx-auto max-w-[520px]" data-id="element-8" data-mp="1ckwlwcnv6po1">
        <h2 className="flex items-center justify-center gap-1.5 text-center font-display text-[21px] uppercase leading-none md:text-[24px]" data-id="element-9" data-mp="1clpk2p8rc6uk">
          <GiftIcon className="h-5 w-5 shrink-0 text-danger" aria-hidden="true" data-id="element-10" data-mp="259v4favwfttv" />5 professional bonuses included
        </h2>
        <ul className="mt-4 space-y-3.5" data-id="element-11" data-mp="20aikaxwex0uz">
          {bonuses.map(b => <li key={b.number} className="rounded-[3px] border border-gold/30 bg-panel px-3.5 py-3" data-id="element-12" data-mp="1w8x0eslgnmba">
              <h3 className="flex items-start gap-1 font-display text-[12px] uppercase leading-tight text-gold" data-id="element-13" data-mp="1racablzxaj0k">
                <GiftIcon className="mt-[1px] h-3 w-3 shrink-0" aria-hidden="true" data-id="element-14" data-mp="kujjk7p4k74r" />
                Bonus {b.number} — {b.title}
              </h3>
              <p className="mt-0.5 text-[9.5px] font-extrabold uppercase tracking-[0.03em] text-white" data-id="element-15" data-mp="ftm07rsdp71o">{b.subtitle}</p>
              <p className="mt-1 text-[11px] leading-[1.55] text-white/75" data-id="element-16" data-mp="1eru5cv32ivfu">{b.description}</p>
              <p className="mt-1 text-[9.5px] font-extrabold uppercase tracking-[0.06em] text-gold" data-id="element-17" data-mp="1jqdrowlkq98q">{b.tagline}</p>
            </li>)}
        </ul>
      </div>
    </section>;
}